import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Plus from '@spa/shared/svg/plus';
import Minus from '@spa/shared/svg/minus';
import { Wrapper } from './styles';

const Counter = ({ max = null, min = 1, value, increment = 1, onUpdate = () => {} }) => {
  const [count, setCount] = useState(value);

  useEffect(() => {
    setCount(value);
  }, [value]);

  const incrementCount = () => {
    if (max && count === max) {
      return;
    }

    setCount(count + increment);
    onUpdate(count + increment);
  };

  const decrementCount = () => {
    if (min && count === min) {
      return;
    }

    setCount(count - increment);
    onUpdate(count - increment);
  };

  return (
    <Wrapper>
      <button onClick={decrementCount} disabled={count === min}>
        <Minus />
      </button>
      <span>{count}</span>
      <button onClick={incrementCount} disabled={count === max}>
        <Plus />
      </button>
    </Wrapper>
  );
};

Counter.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  value: PropTypes.number,
  increment: PropTypes.number,
  onUpdate: PropTypes.func
};

export default Counter;
